import { duration } from '@shared';

export const getAnomalyPosition = (videoDuration: number, start: number, end: number) => {
  const left = (start / videoDuration) * 100;
  const width = (duration(start, end) / videoDuration) * 100;

  return { left, width };
};
